import { render, staticRenderFns } from "./PageTitleDesktop.vue?vue&type=template&id=39618da0&scoped=true&"
import script from "./PageTitleDesktop.vue?vue&type=script&lang=js&"
export * from "./PageTitleDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PageTitleDesktop.vue?vue&type=style&index=0&id=39618da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39618da0",
  null
  
)

export default component.exports